<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-button
          v-b-modal="'myModal'"
          class="ml-2 btn-pill"
          size="sm"
          variant="primary"
        >
          <i class="fa fa-plus"></i> Agregar contenido
        </b-button>
        <b-spinner
          v-if="loading"
          variant="primary"
          class="ml-2 mt-1"
          small
          label="Small Spinner"
        ></b-spinner> </b-row
      ><!--/.row-->
    </div>

    <!-- Modal Component -->
    <b-modal
      id="myModal"
      title="Agregar detalles"
      v-model="formModal.status"
      @cancel="resetDetailForm"
      @ok="submit"
      @show="$v.$reset()"
      @shown="getCompanyFacilities(company)"
      size="xl"
      ref="modal"
    >
      <b-row>
        <b-col lg="3">
          <h4 class="border-bottom border-info pb-2">Del producto</h4>
          <b-form-group label="Producto">
            <b-form-select
              id="product"
              @change="getProductSet"
              :disabled="disabledFields.product"
              :state="
                $v.contentData.product.$dirty
                  ? !$v.contentData.product.$error
                  : null
              "
              v-model="$v.contentData.product.$model"
              :options="products"
            />
          </b-form-group>

          <b-form-group label="Variedad" label-for="basicSelect">
            <b-form-select
              id="varietySelect"
              :disabled="disabledFields.variety"
              :state="
                $v.contentData.variety.$dirty
                  ? !$v.contentData.variety.$error
                  : null
              "
              v-model="$v.contentData.variety.$model"
              :options="productSet.varieties"
              value="Seleccione..."
            />
          </b-form-group>

          <b-form-group label="Condicion" label-for="basicSelect">
            <b-form-select
              id="conditionSelect"
              :disabled="disabledFields.condition"
              :state="
                $v.contentData.condition.$dirty
                  ? !$v.contentData.condition.$error
                  : null
              "
              v-model="$v.contentData.condition.$model"
              :options="conditions"
              value="Seleccione..."
            />
          </b-form-group>

          <b-form-group label="Huerto (CSG)" label-for="basicSelect">
            <b-form-select
              id="originSelect"
              :state="
                $v.contentData.origin.$dirty
                  ? !$v.contentData.origin.$error
                  : null
              "
              v-model="$v.contentData.origin.$model"
              :options="companyFacilities.origins"
              :disabled="disabledFields.origin"
              value="origins[0].value"
            />
          </b-form-group>
        </b-col>

        <b-col lg="3">
          <h4 class="border-bottom border-info pb-2">Opciones</h4>

          <b-form-group label="Completar pallet" label-for="basicRadiosCustom2">
            <b-form-checkbox
              id="checkbox-2"
              v-model="existing_pallet"
              name="checkbox-2"
            >
              Pallet existente
            </b-form-checkbox>
          </b-form-group>

          <!--    <b-form-group
            label="Otros"
            label-for="basicCustomCheckboxes">
            <b-form-checkbox-group stacked id="basicCustomCheckboxes">
              <div class="custom-control custom-checkbox pb-1">
                <input type="checkbox" v-model="contentData.other" class="custom-control-input" id="customChk1"
                       value="gasificado">
                <label class="custom-control-label" for="customChk1">Gasificado</label>
              </div>
              <div class="custom-control custom-checkbox pb-1">
                <input type="checkbox" v-model="contentData.other" class="custom-control-input" id="customChk2"
                       value="a piso">
                <label class="custom-control-label" for="customChk2">A piso</label>
              </div>
              <div class="custom-control custom-checkbox pb-1">
                <input type="checkbox" v-model="contentData.other" class="custom-control-input" id="customChk3"
                       value="mallas">
                <label class="custom-control-label" for="customChk3">En mallas</label>
              </div>
              <div class="custom-control custom-checkbox pb-1">
                <input type="checkbox" v-model="contentData.other" class="custom-control-input" id="customChk4"
                       value="insectos">
                <label class="custom-control-label" for="customChk4">Presencia de insectos</label>
              </div>
              <div class="custom-control custom-checkbox pb-1">
                <input type="checkbox" v-model="contentData.other" class="custom-control-input" id="customChk5"
                       value="horario">
                <label class="custom-control-label" for="customChk5">Fuera de horario de recepcion</label>
              </div>
              <div class="custom-control custom-checkbox pb-1">
                <input type="checkbox" v-model="contentData.other" class="custom-control-input" id="customChk6"
                       value="iqf_campo">
                <label class="custom-control-label" for="customChk6">IQF de campo</label>
              </div>

            </b-form-checkbox-group>
          </b-form-group> -->
        </b-col>

        <b-col lg="3">
          <h4 class="border-bottom border-info pb-2">Del resultado</h4>

          <b-form-group
            v-if="existing_pallet === true"
            label="Pallet"
            label-for="palletSelect"
          >
            <b-form-select
              id="palletSelect"
              v-model="contentData.pallet"
              :options="pallets"
              value="Seleccione..."
            />
          </b-form-group>

          <b-form-group label="Tipo de producto" label-for="processTypeSelect">
            <b-form-select
              id="processTypeSelect"
              @change="changeTipoProducto($event)"
              :disabled="disabledFields.product_type"
              :state="
                $v.contentData.product_type.$dirty
                  ? !$v.contentData.product_type.$error
                  : null
              "
              v-model="$v.contentData.product_type.$model"
              value="Seleccione..."
            >
              <option
                v-for="product_type in productSet.product_types"
                v-bind:value="{
                  id: product_type.value,
                  text: product_type.text,
                  exportable: product_type.exportable
                }"
              >
                {{ product_type.text }}
              </option>
            </b-form-select>
          </b-form-group>

          <b-form-group label="Formato/Recipiente" label-for="containerSelect">
            <b-form-select
              id="containerSelect"
              :state="
                $v.contentData.container.$dirty
                  ? !$v.contentData.container.$error
                  : null
              "
              v-model="$v.contentData.container.$model"
              :options="productSet.containers"
              value="Seleccione..."
            />
          </b-form-group>

          <b-form-group
            v-if="contentData.interplanta === true"
            label="Planta de proceso (CSP)"
            label-for="plantSelect"
          >
            <b-form-select
              id="plantSelect"
              v-model="contentData.plant"
              :options="companyFacilities.plants"
              :disabled="disabledFields.plant"
              value="Seleccione..."
            />
          </b-form-group>

          <div v-if="contentData.interplanta === true">
            <b-form-group
              v-for="(type, index) in productSet.spec_type"
              v-bind:label="type.name"
              :key="index"
              label-for="basicSelect"
            >
              <b-form-select
                id="specSelect"
                v-model="contentData.specifications[index]"
              >
                <option
                  v-for="spec in type.specs"
                  :key="spec.value"
                  v-bind:value="spec.value"
                >
                  {{ spec.text }}
                </option>
              </b-form-select>
            </b-form-group>
          </div>
        </b-col>
        <b-col lg="3">
          <h4 class="border-bottom border-info pb-2">De los números</h4>

          <b-form-group
            id="example-input-group-1"
            aria-describedby="input-1-live-feedback"
            label="Cantidad"
            description="Por favor, cuente la Formato/Recipiente antes de registrar."
            label-for="basicNumber"
          >
            <b-input-group>
              <b-form-input
                type="text"
                placeholder="Ingrese unidades resultantes"
                :state="
                  $v.contentData.quantity.$dirty
                    ? !$v.contentData.quantity.$error
                    : null
                "
                v-model="$v.contentData.quantity.$model"
              >
              </b-form-input>

              <b-input-group-append>
                <b-input-group-text>Un</b-input-group-text>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>

          <b-form-group
            description="Los kilos que indica la pesa/romana."
            label="Kilos brutos"
            label-for="basicNumber"
          >
            <b-input-group>
              <b-form-input
                type="text"
                :state="
                  $v.contentData.gross_kilograms.$dirty
                    ? !$v.contentData.gross_kilograms.$error
                    : null
                "
                v-model="$v.contentData.gross_kilograms.$model"
                :disabled="contentData.interplanta === true"
                placeholder="Ingrese kilos"
              >
              </b-form-input>
              <b-input-group-append>
                <b-input-group-text>Kg</b-input-group-text>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>

          <!--Kilos Netos-->
          <b-form-group
            label="Kilos netos"
            label-for="elementsAppend"
            description=""
          >
            <b-input-group>
              <b-form-input
                type="text"
                :value="calculateNet"
                placeholder="Calculando kilos..."
                disabled
              >
              </b-form-input>
              <b-input-group-append>
                <b-input-group-text>Kg</b-input-group-text>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>

          <b-form-group
            label="Kilos en origen (opcional)"
            label-for="basicNumber"
          >
            <b-input-group>
              <b-form-input
                type="text"
                :value="calculateNet"
                :state="
                  $v.contentData.origin_kilograms.$dirty
                    ? !$v.contentData.origin_kilograms.$error
                    : null
                "
                v-model="$v.contentData.origin_kilograms.$model"
                placeholder="Ingrese kilos"
              >
              </b-form-input>
              <b-input-group-append>
                <b-input-group-text>Kg</b-input-group-text>
              </b-input-group-append>
              <b-form-text id="inputLiveHelp">
                Los kilos anunciados por el emisor de la guía de despacho. Hay
                una diferencia de <b>{{ kilogramDif }}</b>
                %
              </b-form-text>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { decimal, integer, minValue, required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import { bus } from "../../main";
import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";
import Vue from "vue";

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

Vue.use(VueNotifications);
Vue.use(miniToastr);

export default {
  name: "modals",
  components: {},
  // This props are receiving the data from the parent component
  props: [
    "company",
    "client_customer",
    "waybillID",
    "formModal",
    "waybillDATE"
  ],
  data() {
    return {
      loading: false,
      modalTitle: "Agregar detalles",
      editing_modal: false,
      contentData: {
        id: null,
        pallet_number: "",
        interplanta: false,
        product: "",
        variety: "",
        condition: "",
        origin: "",
        product_type: {
          exportable: null
        },
        plant: "",
        pallet: "",
        process_date: "",
        container: "",
        specifications: [],
        quantity: null,
        gross_kilograms: null,
        net_kilograms: null,
        origin_kilograms: "",
        other: []
      },
      productSet: {
        product_types: [],
        containers: [],
        varieties: [],
        spec_type: []
      },
      companyFacilities: [],
      existing_pallet: false,
      pallets: [],
      products: [],
      conditions: [
        { value: "Orgánico", text: "Orgánico" },
        { value: "Convencional", text: "Convencional" },
        { value: "Org. System Approach", text: "Org. System Approach" },
      ],
      disabledFields: {
        product: false,
        variety: false,
        condition: false,
        origin: false,
        plant: false
      }
    };
  },
  validations: {
    contentData: {
      product: { required },
      variety: { required },
      origin: { required },
      condition: { required },
      product_type: { required },
      plant: { required },
      container: { required },
      origin_kilograms: { decimal },
      quantity: {
        required,
        integer,
        minValue: minValue(1)
      },
      // net_kilograms: {
      //   required,
      //   decimal,
      //   minValue : minValue(0)
      // },
      gross_kilograms: {
        required,
        decimal,
        minValue: minValue(0.01)
      }
    }
  },
  computed: {
    kilogramDif() {
      var num =
        ((this.contentData.net_kilograms - this.contentData.origin_kilograms) /
          this.contentData.origin_kilograms) *
        100;
      return num.toFixed(2);
    },
    calculateExport() {
      const num =
        parseFloat(this.contentData.container.net_weight) *
          this.contentData.quantity || 0;
      return this.contentData.interplanta
        ? num
        : this.contentData.net_kilograms;
    },
    calculateNet() {
      if (this.contentData.interplanta) {
        const num = parseFloat(this.calculateExport);
        this.contentData.gross_kilograms = this.calculateExport.toFixed(2);
        return isNaN(num) ? "En espera..." : parseFloat(num).toFixed(2);
      } else {
        const num = (this.contentData.gross_kilograms - 17).toFixed(2);
        return isNaN(num) ? "En espera..." : parseFloat(num).toFixed(2);
      }

      // return this.contentData.net_kilograms
    }
  },
  watch: {
    existing_pallet: {
      handler(val) {
        this.getWaybillPallets(this.waybillID);
      }
    },
    "contentData.product_type": {
      handler(val) {
        this.getProductContainers(val.exportable, this.contentData.product);
      }
    }
  },
  created() {
    bus.$on("contentEditing", (data) => {
      this.contentData.container = "";
      this.contentData.container = data.container;

      this.editing_modal = true;
      this.existing_pallet = true;
      this.getWaybillPallets(this.waybillID);
      this.contentData.product = data.product;
      this.contentData.id = data.id;

      // First select product to run the apis and fill the select inputs. Then continue filling the modal inputs.
      this.getProductSet(data.product);
      this.contentData.variety = data.variety;
      this.contentData.condition = data.condition;
      this.contentData.pallet = data.pallet;
      this.contentData.origin = data.origin;
      this.contentData.interplanta = data.exportable;

      const specs = [];
      for (let key in data.specifications) {
        const spec = data.specifications[key].id;
        specs.push(spec);
      }
      this.contentData.specifications = specs;

      this.contentData.quantity = data.quantity;
      this.contentData.net_kilograms = data.net_kilograms;
      this.contentData.origin_kilograms = data.origin_kilograms;
      this.contentData.gross_kilograms = data.gross_kilograms;
      this.contentData.product_type = {
        id: data.product_type,
        text: data.product_type_name,
        exportable: data.exportable
      };
      // this.getProductContainers(data.container.bulk, data.product);

      // this.contentData.container ={'id': data.container.id, 'net_weight': data.container.net_weight};

      this.formModal.status = true;
    });
  },
  methods: {
    resetDetailForm() {
      this.contentData.id = null;
      this.contentData.origin = null;
      this.contentData.interplanta = false;
      this.contentData.product = null;
      this.contentData.variety = null;
      this.contentData.condition = null;
      this.contentData.product_type = [
        {
          exportable: null
        }
      ];
      this.contentData.plant = null;
      this.contentData.pallet = null;
      this.contentData.process_date = null;
      this.contentData.container = "";
      this.contentData.specifications = [];
      this.contentData.quantity = 0;
      this.contentData.gross_kilograms = null;
      this.contentData.net_kilograms = 0;
      this.contentData.origin_kilograms = null;
      this.contentData.other = [];
      this.productSet = {
        product_types: [],
        containers: [],
        varieties: [],
        spec_type: []
      };
      this.existing_pallet = false;
    },

    // ******** Getting variables based on selections

    getProducts() {
      this.$axios
        .get("/production/get_products/")
        .then((res) => {
          // console.log(res)
          const data = res.data.data;
          const products = [];
          for (let key in data) {
            const product = data[key];
            products.push(product);
          }
          this.products = products;
        })
        .catch((error) => console.log(errors));
    },

    getCompanyFacilities(a) {
      this.$axios
        .get("/production/get_company_facilities/" + a)
        .then((res) => {
          this.companyFacilities = res.data;
          this.contentData.plant = this.companyFacilities.plants[0].value;
          this.contentData.origin = this.companyFacilities.origins[0].value;
          this.disabledFields.plants = false;
          this.disabledFields.origins = false;
        })
        .catch((error) => {
          this.disabledFields.plants = true;
        });
    },
    getProductContainers(exportable, product) {
      if (product == null) {
      } else {
        const url = exportable ? "std" : "bulk";
        this.$axios
          .get("/api/v1/container/" + product + "/" + url + "/")
          .then((res) => {
            this.productSet.containers = res.data;
          })
          .catch((error) => console.log(error.menssaje));
      }
    },
    getProductSet(a) {
      this.$axios
        .get("/production/get_product_set/" + a)
        .then((res) => {
          this.productSet.spec_type = res.data.spec_type;
          this.productSet.varieties = res.data.varieties;

          const items = [];
          for (let key in res.data.product_types) {
            if (res.data.product_types[key].waste == false) {
              items.push(res.data.product_types[key]);
            }
          }

          this.productSet.product_types = items;
        })
        .catch((error) => console.log(error));
    },
    changeTipoProducto(obj) {
      if (obj.exportable == true) {
        this.contentData.interplanta = true;
      } else {
        this.contentData.specifications = [];
        this.contentData.interplanta = false;
      }
    },

    // ********  End getting variables based on selections

    getWaybillPallets(a) {
      this.$axios
        .get("/production/get_waybill_pallets/" + a)
        .then((res) => {
          const data = res.data.data;
          const items = [];
          for (let key in data) {
            const item = data[key];
            items.push(item);
          }
          this.pallets = items;
        })
        .catch((error) => console.log(errors));
    },
    submit: function (evt) {
      evt.preventDefault();
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$emit("validate", false);
      } else {
        this.$emit("validate", true);
        if (this.contentData.id === null) {
          this.createContent();
        } else {
          this.updateContent(this.contentData.id);
        }
        this.resetDetailForm();
        this.$refs.modal.hide();
      }
    },
    createContent() {
      this.formModal.status = false;

      if (this.existing_pallet == false) {
        const palletData = {
          number: this.contentData.pallet_number,
          receipt_waybill: this.waybillID,
          client: this.$store.getters.user.ID_CLIENTE,
          tipo: 1,
          contents: [
            {
              quantity: Number(this.contentData.quantity),
              net_kilograms: Number(this.calculateNet),
              origin_kilograms: Number(this.contentData.origin_kilograms),
              gross_kilograms: Number(this.contentData.gross_kilograms),
              origin: this.contentData.origin,
              condition: this.contentData.condition,
              product_type: this.contentData.product_type.id,
              pallet: "",
              process_id: "",
              overweight_type: "0",
              creation_date: this.waybillDATE,
              variety: this.contentData.variety,
              client_customer: this.client_customer,
              plant: this.contentData.plant,
              waybill: this.waybillID,
              container: this.contentData.container.id,
              specifications: this.contentData.specifications.filter(Boolean),
              classification: "",
              palletizing: ""
            }
          ]
        };
        this.loading = true;
        this.$axios
          .post("/api/v1/content/create_process_content/", palletData)
          .then((res) => {
            if (res.data.status == 1) {
              this.loading = false;
              this.formModal.status = false;
              this.resetDetailForm();
              this.$emit("refreshContents", this.waybillID);
              miniToastr.success("Operación realizada con éxito", "");
            }

            if (res.data.status == 2) {
              miniToastr.error("Numero de pallet ingresado ya éxiste", "");
            }
          })
          .catch((error) => {
            miniToastr.error("Problemas al realizar la operación", "");
          });
      }
      if (this.existing_pallet == true) {
        this.formModal.status = false;

        const palletData = {
          number: this.contentData.pallet_number,
          receipt_waybill: this.waybillID,
          client: this.$store.getters.user.ID_CLIENTE,
          tipo: 2,
          contents: [
            {
              quantity: Number(this.contentData.quantity),
              net_kilograms: Number(this.calculateNet),
              origin_kilograms: Number(this.contentData.origin_kilograms),
              gross_kilograms: Number(this.contentData.gross_kilograms),
              origin: this.contentData.origin,
              condition: this.contentData.condition,
              product_type: this.contentData.product_type.id,
              pallet: this.contentData.pallet,
              process_id: "",
              overweight_type: "0",
              creation_date: this.waybillDATE,
              variety: this.contentData.variety,
              client_customer: this.client_customer,
              plant: this.contentData.plant,
              waybill: this.waybillID,
              container: this.contentData.container.id,
              specifications: this.contentData.specifications.filter(Boolean),
              classification: "",
              palletizing: ""
            }
          ]
        };
        this.loading = true;
        this.$axios
          .post("/api/v1/content/create_process_content/", palletData)
          .then((res) => {
            if (res.data.status == 1) {
              this.loading = false;
              this.formModal.status = false;
              this.resetDetailForm();
              this.$emit("refreshContents", this.waybillID);
              miniToastr.success("Operación realizada con éxito", "");
            }

            if (res.data.status == 2) {
              miniToastr.error("Numero de pallet ingresado ya éxiste", "");
            }
          })
          .catch((error) => {
            console.log(error.response);
          });
      }
    },
    updateContent(a) {
      const formData = {
        number: this.contentData.pallet_number,
        receipt_waybill: this.waybillID,
        tipo: 0,
        contents: [
          {
            id: a,
            quantity: Number(this.contentData.quantity),
            net_kilograms: Number(this.calculateNet),
            origin_kilograms: Number(this.contentData.origin_kilograms),
            gross_kilograms: Number(this.contentData.gross_kilograms),
            origin: this.contentData.origin,
            condition: this.contentData.condition,
            product_type: this.contentData.product_type.id,
            pallet: this.contentData.pallet,
            process_id: "",
            creation_date: this.waybillDATE,
            variety: this.contentData.variety,
            client_customer: this.client_customer,
            plant: this.contentData.plant,
            waybill: this.waybillID,
            overweight_type: "0",
            container: this.contentData.container.id,
            specifications: this.contentData.specifications.filter(Boolean),
            classification: "",
            palletizing: ""
          }
        ]
      };
      this.formModal.status = false;
      this.editing_modal = false;
      this.loading = true;
      this.$axios
        .put("/api/v1/content/update_process_content/", formData)
        .then((res) => {
          this.loading = false;
          this.resetDetailForm();
          this.$emit("refreshContents", this.waybillID);
          miniToastr.success("Operación realizada con éxito", "");
        })
        .catch((error) => console.log(error));
    },
    toggle() {
      this.contentData.net_kilograms = this.calculateExport;
      this.contentData.interplanta = !this.interplanta;
    }
  },
  beforeMount() {
    this.getProducts();
  }
};
</script>
